import { HealthieBaseUrl } from '@/constants/healthieUrls';
import HOSTS from '@/constants/hosts';
import { healthieApptDate } from '@/utils/dates';

export const healthieLink = ({ host }: { host: string }) =>
  host === HOSTS.production ? HealthieBaseUrl.Production : HealthieBaseUrl.Staging;

export const healthieAppointmentLink = (
  appointmentId: string | number,
  appointmentDate: Date | string,
  host: string
): string => {
  if (!appointmentId || !appointmentDate) {
    throw new Error('Both appointmentId and appointmentDate are required to generate the link.');
  }

  //secure.gethealthie.com/organization?rel_appt_id=72625067&rel_appt_date=20250626
  const baseUrl = healthieLink({ host });
  return `${baseUrl}/organization?rel_appt_id=${appointmentId}&rel_appt_date=${healthieApptDate(
    appointmentDate
  )}`;
};

export const healthieProviderAppointmentsLink = (
  appointmentId: string | number,
  appointmentDate: Date | string,
  host: string
): string => {
  if (!appointmentId || !appointmentDate) {
    throw new Error('Both appointmentId and appointmentDate are required to generate the link.');
  }

  //securestaging.gethealthie.com/appointments?rel_appt_id=3887358&rel_appt_date=20260923
  const baseUrl = healthieLink({ host });
  return `${baseUrl}/appointments?rel_appt_id=${appointmentId}&rel_appt_date=${healthieApptDate(
    appointmentDate
  )}`;
};

export const healthieChartLink = (
  chartId: string | number,
  personHealthieId: string | number,
  host: string
): string => {
  // https://secure.gethealthie.com/users/6368802/private_notes/view/50459795
  const baseUrl = healthieLink({ host });
  return `${baseUrl}/users/${personHealthieId}/private_notes/view/${chartId}`;
};
